import { isNullOrWhitespace } from '@/helpers/stringHelper';
import { Validator } from 'vee-validate';

const getDefaultState = () => {
    return {
        ZipCode: null,
        Street: null,
        Number: null,
        Complement: null,
        District: null,
        City: null,
        State: null,
        FetchedFields: []
    };
};

export default {
    namespaced: true,

    state: () => getDefaultState(),

    getters: {
        getSubmitModel(state) {
            return {
                ShippingAddress: {
                    ZipCode: state.ZipCode,
                    Street: state.Street,
                    Number: state.Number,
                    Compl: state.Complement,
                    District: state.District,
                    City: state.City,
                    State: state.State
                }
            };
        },

        getTargetZipCode(state) {
            return state.ZipCode;
        }
    },

    mutations: {
        setZipCode: (state, zipCode) => (state.ZipCode = zipCode),
        setStreet: (state, street) => (state.Street = street),
        setNumber: (state, number) => (state.Number = number),
        setComplement: (state, complement) => (state.Complement = complement),
        setDistrict: (state, district) => (state.District = district),
        setCity: (state, city) => (state.City = city),
        setState: (state, _state) => (state.State = _state),

        /**
		 * Mapeia o response da api para o módulo
		 */
        setFromRequest(state, data) {
            state.FetchedFields = [];
            if (!data) return;

            MapAddress(state, data);
            MapCommonFetchedFields(state);

            if (isNullOrWhitespace(state.Complement) == false)
                state.FetchedFields.push('complement');
            if (isNullOrWhitespace(state.Number) == false)
                state.FetchedFields.push('number');
            if (isNullOrWhitespace(state.ZipCode) == false)
                state.FetchedFields.push('zipcode');
        },

        ADDRESS_UPDATED(state, data) {
            state.FetchedFields = [];
            if (!data) return;

            MapAddress(state, data);
            MapCommonFetchedFields(state);
        },

        resetState(state) {
            Object.assign(state, getDefaultState());
        }
    },

    actions: {
        /**
		 * Aplica reset no state quando o campo Zip Code for vazio
		 */
        resetState({ commit }) {
            commit('shippingAddress/resetState', null, { root: true });
        }
    }
};

function validateAndSplitValue(value, maxLength) {
    const v = new Validator();
    const { valid } = v.verify(value, `max:${maxLength}`);

    if (valid) {
        return value;
    } else if(value) {
        return value.slice(0, maxLength);
    }
    return null;
}


//Helpers
function MapAddress(state, data) {
    state.Street = data.Street || data.Name;
    state.Number = validateAndSplitValue(data.Number, 8);
    state.Complement = data.Complement || null;
    state.District = data.District;
    state.City = data.City;
    state.State = data.State;
    state.ZipCode = data.ZipCode;
}

function MapCommonFetchedFields(state) {
    if (isNullOrWhitespace(state.Street) == false)
        state.FetchedFields.push('street');
    if (isNullOrWhitespace(state.District) == false)
        state.FetchedFields.push('district');
    if (isNullOrWhitespace(state.City) == false)
        state.FetchedFields.push('city');
    if (isNullOrWhitespace(state.State) == false)
        state.FetchedFields.push('state');
}
